import React, { useEffect } from 'react';
// import { Button } from '@material-ui/core';
import { useLocation, Link as RouterLink } from 'umi';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  // Avatar,
  Box,
  // Chip,
  Divider,
  Drawer,
  Hidden,
  Link,
  List,
  // ListSubheader,
  Typography,
  // makeStyles,
} from '@material-ui/core';
import webStorage from '@/utils/storageManager';
import NavItem from './NavItem';
import { MENU_CONFIG, vipDataMap } from '@/constants';
// import SvgIconML from '@/components/SvgIconML/SvgIconML';
// import { getToken } from '@/utils/token';

function renderNavItems({ items, ...rest }) {
  return (
    <List key={'LIST_' + rest.key} disablePadding>
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, ...rest }),
        [],
      )}
    </List>
  );
}
//生成唯一id
function guid() {
  return Number(Math.random().toString().substr(3, 3) + Date.now()).toString(
    36,
  );
}
function reduceChildRoutes({
  acc,
  pathname,
  item,
  depth = 0,
  parentBreadcrumbItems = [],
}) {
  const key = item.title + depth + guid();
  const tenantId = webStorage.get('TENANT_ID');

  // 完整层级菜单对象数组（父级 + 自己），用于点击时写入 sessionStorage。
  const breadcrumbItems = [...parentBreadcrumbItems, item];

  if (item.items) {
    acc.push(
      <NavItem
        key={key}
        depth={depth}
        open={true}
        breadcrumbItems={breadcrumbItems}
        {...item}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items,
          key: 'LIST_' + key,
          parentBreadcrumbItems: breadcrumbItems,
        })}
      </NavItem>,
    );
  } else {
    if (tenantId !== '10000') {
      if (item.title === '直营市场会员数据') {
        item.title = '经销商会员数据';
      } else if (item.title === '大连会员数据') {
        item.title = `${vipDataMap.get(tenantId) || ''}会员数据`;
      }
    }
    acc.push(
      <NavItem
        key={key}
        depth={depth}
        breadcrumbItems={breadcrumbItems}
        {...item}
      />,
    );
  }

  return acc;
}

function NavBar({ openMobile, onMobileClose }) {
  const location = useLocation();
  // const { user } = useSelector((state) => state.account);
  // const MENU_TICKET_SYSTEM = webStorage
  //   .get('USER')
  //   ?.authorities?.includes('MENU_TICKET_SYSTEM');
  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        {/* <Hidden lgUp>
          <Box p={2} display="flex" justifyContent="center">
            <RouterLink to="/">
              <Logo />
              LOGO
            </RouterLink>
          </Box>
        </Hidden> */}
        <Box p={2}>
          <Box display="flex" justifyContent="center">
            <RouterLink to="/app/account"></RouterLink>
          </Box>
          <Box mt={2} textAlign="center">
            <Link
              component={RouterLink}
              to="/app/account"
              variant="h5"
              color="textPrimary"
              underline="none"
            >
              {/* {`${user.firstName} ${user.lastName}`} */}
              {''}
            </Link>
            <Typography variant="body2" color="textSecondary">
              {/* {user.bio} */}
              {''}
            </Typography>
          </Box>
        </Box>
        <Divider />
        <Box p={0} pt={2}>
          {MENU_CONFIG.map(
            (config) =>
              // <List
              //   key={config.subheader}
              //   subheader={
              //     <ListSubheader disableGutters disableSticky>
              //       {config.subheader}
              //     </ListSubheader>
              //   }
              // >
              renderNavItems({
                items: config.items,
                pathname: location.pathname,
                key: config.subheader,
                parentBreadcrumbItems: [],
              }),
            // </List>
          )}
        </Box>
        {/* {MENU_TICKET_SYSTEM ? (
          <Button
            exact
            sx={{
              width: '100%',
              color: '#616161',
              justifyContent: 'flex-start',
              paddingLeft: '16px',
            }}
            onClick={() => {
              const token = getToken();
              const userId = webStorage.get('USER')?.id;
              window.open(
                `${process.env.SMG_URL}?token=${token}&userId=${userId}`,
              );
            }}
          >
            <SvgIconML name="ticket" size={16}></SvgIconML>
            <span className={'title'}>票务系统</span>
          </Button>
        ) : (
          ''
        )} */}
      </PerfectScrollbar>
    </Box>
  );

  return (
    <>
      <Hidden>
        <div className="sideNav-hidd">
          <Drawer
            className="drawerContainer"
            anchor="left"
            onClose={onMobileClose}
            open={openMobile}
            variant="temporary"
          >
            {content}
          </Drawer>
        </div>
      </Hidden>
      <Hidden>
        <div className="sideNav">
          <Drawer
            className="drawerContainer"
            anchor="left"
            open
            variant="persistent"
          >
            {content}
          </Drawer>
        </div>
      </Hidden>
    </>
  );
}

// NavBar.propTypes = {
//   onMobileClose: PropTypes.func,
//   openMobile: PropTypes.bool
// };

export default NavBar;
